// extracted by mini-css-extract-plugin
module.exports = {"section":"bR_l","headerTitle":"bR_bw","descriptionColumn":"bR_bx","alignCenter":"bR_fP","description":"bR_k"};